export default [
  {
    header: '主菜单',
    resource: 'MY_UNIT',
    action: 'menu',
  },
  {
    title: '招聘公告',
    route: 'RecruitmentAds',
    icon: 'icon-gonggaopai',
    resource: 'RECRUITMENT_ADS',
    action: 'menu',
  },
  {
    title: '投递反馈',
    route: 'ApplicationList',
    icon: 'icon-fabu',
    resource: 'APPLICATION_LIST',
    action: 'menu',
  },
  {
    title: '我的岗位',
    route: 'MyUnit',
    icon: 'icon-lishishujubukedianji',
    resource: 'MY_UNIT',
    action: 'menu',
  },
  {
    title: '月报酬发放记录',
    route: 'MonthlyPaymentRecords',
    icon: 'icon-fafang',
    resource: 'MONTHLY_PAYMENT_RECORDS',
    action: 'menu',
  },
  {
    header: '主菜单',
    resource: 'UNIT_STUDENT_MANAGE',
    action: 'menu',
  },
  {
    title: '岗位及学生管理',
    route: 'UnitStudentManage',
    icon: 'icon-shanghuguanli',
    resource: 'UNIT_STUDENT_MANAGE',
    action: 'menu',
  },
  {
    title: '岗位发布历史',
    route: 'JobHistory',
    icon: 'icon-lishishujubukedianji',
    resource: 'JOB_HISTORY',
    action: 'menu',
  },
  {
    title: '学生上岗审核',
    route: 'stuCheck',
    icon: 'icon-shenhetongguo',
    resource: 'STU_CHECK',
    action: 'menu',
  },
  {
    title: '月报酬发放',
    route: 'MonthlyPaymentIssueHistory',
    icon: 'icon-fafang',
    resource: 'MONTHLY_PAYMENT_ISSUE_HISTORY',
    action: 'menu',
  },
  {
    title: '数据统计',
    route: 'UnitDataCount',
    icon: 'icon-tongji',
    resource: 'UNIT_DATA_COUNT',
    action: 'menu',
  },
  {
    header: '主菜单',
    resource: 'EMPLOYMENT_INFORMATION',
    action: 'menu',
  },
  {
    title: '就业信息查询',
    route: 'EmploymentInformation',
    icon: 'icon-gongchengguanli',
    resource: 'EMPLOYMENT_INFORMATION',
    action: 'menu',
  },
  {
    title: '用工单位管理',
    route: 'UnitManger',
    icon: 'icon-gongchengguanli',
    resource: 'UNIT_MANAGER',
    action: 'menu',
  },
  {
    title: '岗位发布审批',
    route: 'ReleaseAudit',
    icon: 'icon-renwu',
    resource: 'RELEASE_AUDIT',
    action: 'menu',
  },
  {
    title: '学生上岗审批',
    route: 'AdminStuCheck',
    icon: 'icon-renwu',
    resource: 'ADMIN_STU_CHECK',
    action: 'menu',
  },
  {
    title: '月报酬发放填写',
    route: 'FillSalaryList',
    icon: 'icon-fafang',
    resource: 'FILL_SALARY_LIST',
    action: 'menu',
  },
  {
    title: '月报酬发放审批',
    route: 'provideList',
    icon: 'icon-fafang',
    resource: 'FILL_SALARY_LIST',
    action: 'menu',
  },
  {
    title: '先进单位评选',
    route: 'UnitRatingManager',
    resource: 'UNIT_RATING_MANAGER',
    action: 'menu',
  },
  {
    title: '数据统计',
    route: 'AdminDataCount',
    icon: 'icon-tongji',
    resource: 'ADMIN_DATA_COUNT',
    action: 'menu',
  },
  {
    title: '配置',
    route: 'Setting',
    icon: 'icon-shanghuguanli',
    resource: 'SETTING',
    action: 'menu',
  },
]
